export const SET_STATES_OPTION = 'SET_STATES_OPTION';



// WEBPACK FOOTER //
// ./src/actions/stateOptions/types.js